import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const ContentTitle = styled("div")({
  marginBottom: 7,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& > span": {
    fontFamily: "Manrope",
    fontSize: 18,
    fontWeight: 700,
    color: colors.gray600,
  },
});

export const Dropzone = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  padding: "24px 1.5px 1.5px",
  width: "100%",
  cursor: "pointer",
}));

export const DropzoneButton = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",

  borderColor: colors.gray200,
  borderRadius: "8px",
  borderStyle: "dashed",
  borderWidth: "3px",

  width: "100%",
  padding: "25px 16px",
}));

export const DropzoneText = styled("p")(() => ({
  color: colors.brandBlue600,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  margin: "0",
}));

export const DropzoneInfoText = styled("p")(() => ({
  alignItems: "center",
  display: "flex",

  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  margin: "0px",
}));

export const DropzoneBoldInfoText = styled(DropzoneInfoText)(() => ({
  textAlign: "center",
  fontWeight: 600,
  letterSpacing: "0.1px",
}));

export const TextWrapper = styled("div")(({ gap }: { gap?: string }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: gap || "4px",
}));

export const PdfViewerWrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  height: 450,
  overflowY: "auto",
  padding: 48,
  backgroundColor: colors.gray200,
});

export const PdfViewerSignatureSection = styled("div")({
  display: "flex",
  alignItems: "center",
  padding: "4px 6px",
  backgroundColor: colors.gray50,
  marginTop: 12,
  borderBottom: `1px solid ${colors.gray300}`,
  gap: 4,

  "& div.tag-badge": {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: 100,
    border: `1px solid ${colors.gray200}`,
    backgroundColor: colors.white,
  },
});

export const PdfViewerSignatureTagOption = styled("div")<{ active?: boolean }>(
  ({ active = false }) => ({
    display: "flex",
    alignItems: "center",
    padding: "4px 8px",
    borderRadius: 4,
    backgroundColor: colors.gray200,
    cursor: "pointer",
    border: active ? `1px solid ${colors.gray400}` : "none",
    "& span": {
      color: colors.gray500,
      fontFamily: "Manrope",
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: 0.5,
    },
  })
);

export const EmptyDocumentWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: 24,
  paddingBottom: 40,
  "& > span": {
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: 0.15,
  },
});
